// app/javascript/dashboard/routes/dashboard/bulkmessage/utils/usePhoneValidation.js
import { ref } from 'vue';

export default function usePhoneValidation() {
  const selectedDDI = ref('+55');

  const countryOptions = [
    { value: '+55', label: '🇧🇷 +55 (Brasil)', name: '🇧🇷 +55 (Brasil)' },
    {
      value: '+1',
      label: '🇺🇸 +1 (Estados Unidos/Canadá)',
      name: '🇺🇸 +1 (Estados Unidos/Canadá)',
    },
    { value: '+351', label: '🇵🇹 +351 (Portugal)', name: '🇵🇹 +351 (Portugal)' },
    { value: '+34', label: '🇪🇸 +34 (Espanha)', name: '🇪🇸 +34 (Espanha)' },
    {
      value: '+44',
      label: '🇬🇧 +44 (Reino Unido)',
      name: '🇬🇧 +44 (Reino Unido)',
    },
    { value: '+49', label: '🇩🇪 +49 (Alemanha)', name: '🇩🇪 +49 (Alemanha)' },
    { value: '+33', label: '🇫🇷 +33 (França)', name: '🇫🇷 +33 (França)' },
  ];

  const validatePhoneNumber = phone => {
    // Return if phone is empty
    if (!phone) return { valid: false, formatted: '' };

    // Convert to string if it's a number
    const phoneStr = String(phone);

    // Remove all non-numeric characters except the leading '+'
    let cleanPhone = phoneStr.replace(/[^\d+]/g, '');

    // Check if phone already starts with '+' indicating it has a country code
    const hasCountryCode = cleanPhone.startsWith('+');

    // Handle international format (starting with +)
    if (hasCountryCode) {
      // Just return the full international number as is, without the +
      return {
        valid: cleanPhone.length >= 8, // Basic validation for international numbers
        formatted: cleanPhone.substring(1), // Remove the + as we'll add it back later
      };
    }

    // Check if phone already has a Brazilian DDI (55)
    const hasBrazilianDDI =
      cleanPhone.startsWith('55') && cleanPhone.length > 10;

    // Remove DDI if present to standardize format
    if (hasBrazilianDDI) {
      cleanPhone = cleanPhone.substring(2);
    }

    // For Brazilian numbers:
    // If the number has 10 digits (without the 9 prefix), insert 9 after DDD
    // This assumes the first 2 digits are the DDD (area code)
    if (cleanPhone.length === 10) {
      // Extract DDD (first 2 digits)
      const ddd = cleanPhone.substring(0, 2);
      // Extract the rest of the number
      const restOfNumber = cleanPhone.substring(2);
      // Insert 9 after DDD
      cleanPhone = ddd + '9' + restOfNumber;
    }

    // More flexible validation - consider different formats valid
    // - 11 digits (Brazilian mobile with 9)
    // - 10 digits (standard landline or old mobile)
    // - 8-9 digits (possibly missing area code, could be supplemented)
    let isValid = cleanPhone.length >= 8 && cleanPhone.length <= 15;

    // More detailed logging to help with debugging
    console.log(
      `Phone validation: "${phoneStr}" -> "${cleanPhone}", length: ${cleanPhone.length}, valid: ${isValid}, origin: raw input`
    );

    return {
      valid: isValid,
      formatted: cleanPhone,
    };
  };

  // Function to format the phone with DDI for the API
  const formatPhoneWithDDI = (phone, ddi) => {
    // If phone is already fully formatted, return it
    if (phone.startsWith('+')) return phone;

    // Remove any '+' from the DDI if present
    const cleanDDI = ddi.replace(/\\+/g, '');

    // Return the formatted phone number with DDI
    return `+${cleanDDI}${phone}`;
  };

  return {
    selectedDDI,
    countryOptions,
    validatePhoneNumber,
    formatPhoneWithDDI,
  };
}
